export enum InventoryTargetingType {
    'WHITELIST' = 1,
    'BLACKLIST' = 2
}
